import { ScgpCustomerType } from "@saleor/graphql";
import {
  CustomerType,
  FormType,
  ParentGroupCode,
  UserDetailMode
} from "@saleor/userManagement/constants";
import * as Yup from "yup";

export const getFormInputData = (
  mode,
  formType,
  groupId,
  _user,
  formikValue,
  groupCode
) => {
  if (mode === UserDetailMode.CREATE && formType === FormType.OTHER) {
    if (groupCode === ParentGroupCode.SECTION) {
      return {
        userParentGroupId: groupId,
        email: formikValue.email,
        firstName: formikValue.firstName,
        lastName: formikValue.lastName,
        groupIds: formikValue.userRoles,

        adUser: formikValue.adUser,
        employeeId: formikValue.employeeId,
        sapId: formikValue.sapId
      };
    }
    return {
      userParentGroupId: groupId,
      email: formikValue.email,
      firstName: formikValue.firstName,
      lastName: formikValue.lastName,
      employeeId: formikValue.employeeId,
      adUser: formikValue.adUser,
      sapId: formikValue.sapId,
      groupIds: formikValue.userRoles,
      scgpBuIds: formikValue.businessUnits,
      scgpSalesOrganizationIds: formikValue.saleOrganizations,
      scgpSalesGroupIds: formikValue.saleGroups,
      scgpDistributionChannelIds: formikValue.distributionChannels,
      scgpDivisionIds: formikValue.divisions,
      scgpSalesOfficeIds: formikValue.saleOffices
    };
  } else if (mode === UserDetailMode.EDIT && formType === FormType.OTHER) {
    if (groupCode === ParentGroupCode.SECTION) {
      return {
        userParentGroupId: groupId,
        email: formikValue.email,
        firstName: formikValue.firstName,
        lastName: formikValue.lastName,
        groupIds: formikValue.userRoles,

        adUser: formikValue.adUser,
        employeeId: formikValue.employeeId,
        sapId: formikValue.sapId
      };
    }
    return {
      userParentGroupId: groupId,
      email: formikValue.email,
      firstName: formikValue.firstName,
      lastName: formikValue.lastName,
      adUser: formikValue.adUser,
      groupIds: formikValue.userRoles,
      employeeId: formikValue.employeeId,
      sapId: formikValue.sapId,
      scgpBuIds: formikValue.businessUnits,
      scgpSalesOrganizationIds: formikValue.saleOrganizations,
      scgpSalesGroupIds: formikValue.saleGroups,
      scgpDistributionChannelIds: formikValue.distributionChannels,
      scgpDivisionIds: formikValue.divisions,
      scgpSalesOfficeIds: formikValue.saleOffices
    };
  } else if (mode === UserDetailMode.CREATE && formType === FormType.SALES) {
    return {
      userParentGroupId: groupId,
      employeeId: formikValue.employeeId,
      email: formikValue.email,
      firstName: formikValue.firstName,
      lastName: formikValue.lastName,
      adUser: formikValue.adUser,
      groupIds: formikValue.userRoles,
      saleId: formikValue.saleId,
      sapId: formikValue.sapId
    };
  } else if (mode === UserDetailMode.EDIT && formType === FormType.SALES) {
    return {
      userParentGroupId: groupId,
      email: formikValue.email,
      firstName: formikValue.firstName,
      lastName: formikValue.lastName,
      employeeId: formikValue.employeeId,
      adUser: formikValue.adUser,
      groupIds: formikValue.userRoles,
      saleId: formikValue.saleId,
      sapId: formikValue.sapId
    };
  } else if (mode === UserDetailMode.CREATE && formType === FormType.CUSTOMER) {
    return {
      userParentGroupId: groupId,
      email: formikValue.email,
      firstName: formikValue.firstName,
      lastName: formikValue.lastName,
      adUser: formikValue.adUser,
      groupIds: formikValue.userRoles,
      customerType: formikValue.customerType.toUpperCase() as ScgpCustomerType,
      companyEmail: formikValue.companyEmail,
      sapId: formikValue.sapId,
      displayName: formikValue.displayName,
      soldToIds: formikValue.soldTo
    };
  } else if (mode === UserDetailMode.EDIT && formType === FormType.CUSTOMER) {
    return {
      userParentGroupId: groupId,
      email: formikValue.email,
      firstName: formikValue.firstName,
      lastName: formikValue.lastName,
      adUser: formikValue.adUser,
      groupIds: formikValue.userRoles,
      customerType: formikValue.customerType.toUpperCase() as ScgpCustomerType,
      companyEmail: formikValue.companyEmail,
      sapId: formikValue.sapId,
      displayName: formikValue.displayName,
      soldToIds: formikValue.soldTo
    };
  }
};

export const getValidationSchema = (mode, formType, groupCode) => {
  if (mode === UserDetailMode.CREATE && formType === FormType.OTHER) {
    if (groupCode === ParentGroupCode.SECTION) {
      return Yup.object().shape({
        adUser: Yup.string().required("โปรดระบุ AD User"),
        userRoles: Yup.array().min(1, "โปรดเลือก User Roles"),
        firstName: Yup.string().required("โปรดระบุชื่อ"),
        lastName: Yup.string().required("โปรดระบุนามสกุล"),
        email: Yup.string()
          .required("โปรดระบุ E-mail")
          .email("รูปแบบของอีเมลไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง"),
        employeeId: Yup.string().required("โปรดระบุ Employee ID")
      });
    }
    return Yup.object().shape({
      adUser: Yup.string().required("โปรดระบุ AD User"),
      userRoles: Yup.array().min(1, "โปรดเลือก User Roles"),
      saleGroups: Yup.array().min(1, "โปรดเลือก Sale Group"),
      distributionChannels: Yup.array().min(
        1,
        "โปรดเลือก Distribution Channel"
      ),
      businessUnits: Yup.array().min(1, "โปรดเลือก BU"),
      saleOrganizations: Yup.array().min(1, "โปรดเลือก Sale Organization"),
      firstName: Yup.string().required("โปรดระบุชื่อ"),
      lastName: Yup.string().required("โปรดระบุนามสกุล"),
      email: Yup.string()
        .required("โปรดระบุ E-mail")
        .email("รูปแบบของอีเมลไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง"),
      employeeId: Yup.string().required("โปรดระบุ Employee ID"),
      divisions: Yup.array().min(1, "โปรดเลือก Division"),
      saleOffices: Yup.array().min(1, "โปรดเลือก Sale Office")
    });
  } else if (mode === UserDetailMode.EDIT && formType === FormType.OTHER) {
    if (groupCode === ParentGroupCode.SECTION) {
      return Yup.object().shape({
        adUser: Yup.string().required("โปรดระบุ AD User"),
        userRoles: Yup.array().min(1, "โปรดเลือก User Roles"),
        firstName: Yup.string().required("โปรดระบุชื่อ"),
        lastName: Yup.string().required("โปรดระบุนามสกุล"),
        email: Yup.string()
          .required("โปรดระบุ E-mail")
          .email("รูปแบบของอีเมลไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง"),
        employeeId: Yup.string().required("โปรดระบุ Employee ID")
      });
    }
    return Yup.object().shape({
      userRoles: Yup.array().min(1, "โปรดเลือก User Roles"),
      saleOrganizations: Yup.array().min(1, "โปรดเลือก Sale Organization"),
      saleGroups: Yup.array().min(1, "โปรดเลือก Sale Group"),
      distributionChannels: Yup.array().min(
        1,
        "โปรดเลือก Distribution Channel"
      ),
      divisions: Yup.array().min(1, "โปรดเลือก Division"),
      saleOffices: Yup.array().min(1, "โปรดเลือก Sale Office")
    });
  } else if (mode === UserDetailMode.CREATE && formType === FormType.SALES) {
    return Yup.object().shape({
      firstName: Yup.string().required("โปรดระบุชื่อ"),
      lastName: Yup.string().required("โปรดระบุนามสกุล"),
      email: Yup.string()
        .required("โปรดระบุ E-mail")
        .email("รูปแบบของอีเมลไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง"),

      employeeId: Yup.string().required("โปรดระบุ Employee ID"),
      userRoles: Yup.array().min(1, "โปรดเลือก User Roles"),
      adUser: Yup.string().required("โปรดระบุ AD User"),
      saleId: Yup.string().required("โปรดระบุ Sale ID")
    });
  } else if (mode === UserDetailMode.EDIT && formType === FormType.SALES) {
    return Yup.object().shape({
      firstName: Yup.string().required("โปรดระบุชื่อ"),
      lastName: Yup.string().required("โปรดระบุนามสกุล"),
      email: Yup.string()
        .required("โปรดระบุ E-mail")
        .email("รูปแบบของอีเมลไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง"),
      employeeId: Yup.string().required("โปรดระบุ Employee ID"),

      userRoles: Yup.array().min(1, "โปรดเลือก User Roles"),
      saleId: Yup.string().required("โปรดระบุ Sale ID")
    });
  } else if (formType === FormType.CUSTOMER) {
    return Yup.object().shape({
      firstName: Yup.string().required("โปรดระบุชื่อ"),
      lastName: Yup.string().required("โปรดระบุนามสกุล"),
      email: Yup.string()
        .required("โปรดระบุ E-mail")
        .email("รูปแบบของอีเมลไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง"),
      adUser: Yup.string().when("customerType", {
        is: CustomerType.INTERNAL,
        then: Yup.string().required("โปรดระบุ AD User")
      }),
      companyEmail: Yup.string()
        .email("รูปแบบของอีเมลไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง")
        .nullable(true),
      userRoles: Yup.array().min(1, "โปรดเลือก User Roles"),
      soldTo: Yup.array().min(
        1,
        "โปรดระบุชื่อลูกค้าเพื่อทำการค้นหา และเลือก Sold To"
      )
    });
  }
};
